import QAList from '@/data/qa/view/list.vue'

const list = {
  path: '/qa',
  name: 'qa-list',
  component: QAList
}

export default [list]
